<ca-icon [name]="name ? name : ('ca-priority-' + priority)"
         [badgeClass]="priority"
         [label]="label"></ca-icon>